<template>
  <div>
    <div class="kpt-activity-log-item">
      <div class="kpt-activity-log-item-icon">
        <font-awesome-icon :icon="['far', parsedMessage.icon]"></font-awesome-icon>
      </div>
      <div class="kpt-activity-log-item-ts">
        <strong>{{format(new Date(parsedMessage.timestamp), 'yyyy-MM-dd')}}</strong>
        <small>{{format(new Date(parsedMessage.timestamp), 'hh:mm a')}}</small>
      </div>
      <div class="kpt-activity-log-item-msg">
        {{parsedMessage.message}} <span v-if="isShowEntityLink"> <router-link :to="parsedMessage.entityLink">View subscription</router-link></span>
        <a v-if="isShowExpandButton" @click="showActivityDetails" href="javascript:void(0)">{{getDetailsLinkText()}}</a>
      </div>
    </div>
    <div class="kpt-activity-log-table" v-if="showTable">
      <b-table :data="getDiffer">
        <b-table-column field="fieldName" label="Field Name" v-slot="props" width="150">
          {{props.row.fieldName}}
        </b-table-column>
        <b-table-column field="oldValue" label="Old Value" v-slot="props" width="175">
          {{props.row.oldValue}}
        </b-table-column>
        <b-table-column field="newValue" label="New Value" v-slot="props" width="175">
          {{props.row.newValue}}
        </b-table-column>
      </b-table>     
    </div>   
  </div>
   
</template>
<script>
/* eslint-disable no-param-reassign */
import { format } from 'date-fns';
import { getDiff } from 'recursive-diff';
import ActivityLogStrings from '../../assets/activity_strings.json';

// this is recursive funcion to extract object to display to the table
// ex: Object: { val: A billingaddress: { city: Tamil Nadu } address: { city: Seattle }}
// FieldName              Value
// ---------------------------------
// val                    A
// billingaddress.city    Tamil Nadu
// address.city           Seattle
function extractSingleObject(obj, fieldName, result) {
  result = result || [];
  const keys = Object.keys(obj);

  keys.forEach((index) => {
    if (obj[index] != null) {
      if (typeof obj[index] != 'object') {
        fieldName = fieldName || '';
        const p = { 
          oldValue: '', 
          newValue: obj[index], 
          fieldName: fieldName + index 
        }
        result.push(p);
      } else {
        fieldName = fieldName ? `${fieldName}${index}.` : `${index}.`;
        extractSingleObject(obj[index], fieldName, result);
        fieldName = null;
      }
    }
  });
  return result;
}

export default {
  data() {
    return {
      format,   
      showTable: false
    }
  },
  props: {
    model: Object,
    excludeName: Boolean
  },
  computed: {
    /*
      [[u]] - User name
      [[e]] - Entity name
      [[c]] - Affected entity name (changed)
      */
    parsedMessage() {
      if (!this.model) return { icon: 'question-circle', message: 'Action not recognized.', timestamp: this.model.timestamp }
      const action = ActivityLogStrings.find(a => a.action == this.model.action);
      if (!action) return { icon: 'question-circle', timestamp: this.model.timestamp, message: `Action [${this.model.action}] not recognized.` }
      const entityLink = this.isShowEntityLink ? `/subscriptions/${this.entityId}/overview` : null;
      const returnObject = { 
        icon: action.icon, 
        timestamp: this.model.timestamp, 
        message: action.message, 
        entityLink 
      };
      if (action.message.includes('[[u]]') && !this.excludeName) {
        returnObject.message = returnObject.message.replace('[[u]]', this.model.userName);
      } else {
        const replaced = returnObject.message.replace('[[u]]', '').trim();
        returnObject.message = replaced.charAt(0).toUpperCase() + replaced.trim().slice(1);
      }
      if (action.message.includes('[[e]]')) {
        returnObject.message = returnObject.message.replace('[[e]]', this.model.entityName ? this.model.entityName : '');
      }
      if (action.message.includes('[[c]]')) {
        returnObject.message = returnObject.message.replace('[[c]]', this.model.fieldName || 'the');
      }
      return returnObject;
    },
    isShowEntityLink() {
      return this.model.entityType == 'remotes' && (this.model.action == 'addremotetosubscription' || this.model.action == 'addsubscription');
    },
    entityId() {
      let subId = '';
      if (this.isShowEntityLink) {
        // parse the new value if it's JSON format
        try {
          const modelObj = JSON.parse(this.model.newValue);
          subId = !!modelObj && !!modelObj.Id ? modelObj.Id : '';
        } catch (e) {
          subId = this.model.newValue ? this.model.newValue : '';
        }
      }
      return subId;
    },
    isShowExpandButton() {
      // hide expand button for addsubscription for remotes entityType.       
      // hide expand butoon if both new and old value are same
      return !this.isShowEntityLink && (this.model.oldValue != this.model.newValue) && (this.model.newValue || this.model.oldValue);
    },
    getDiffer() {
      let result = [];
      let fieldName = null;      
      let newValue = null;
      let oldValue = null;
      if (this.isShowExpandButton) {
        // parse the new and old value if it's JSON format
        try {
          oldValue = JSON.parse(this.model.oldValue);
        } catch (e) {
          oldValue = this.model.oldValue ? this.model.oldValue : null;
        }

        try {
          newValue = JSON.parse(this.model.newValue);
        } catch (e) {
          newValue = this.model.newValue ? this.model.newValue : null;
        }

        // get the fieldName for old activity log
        if (this.model.fieldName) {
          fieldName = this.model.fieldName;
        }
        // both new and old value are JSON then do the recursive diff
        if ((oldValue && typeof (oldValue) == 'object') && (newValue && typeof (newValue == 'object'))) {
          const diff = getDiff(oldValue, newValue, true);

          // eslint-disable-next-line no-unused-vars
          diff.forEach((item, index) => {
            const name = item.path.length ? item.path.join('.') : '';
            let disObj;
            // Billed account only show for kymeta admin user
            if (name.includes('BilledAccount')) {
              if (this.$hasRole('Super User,Kymeta Admin')) {
                disObj = {
                  oldValue: item.oldVal, newValue: item.val, fieldName: name
                };                  
                result.push(disObj);
              }
            } else {
              disObj = {
                oldValue: item.oldVal, newValue: item.val, fieldName: name
              };
              result.push(disObj);
            }              
          });
        // extract object if it's any one of the (old or new) value are JSON format and another one are null or empty
        } else if ((oldValue && typeof (oldValue) == 'object') || (newValue && typeof (newValue) == 'object')) {           
          result = extractSingleObject(newValue || oldValue);
        // if it's old or new value are not in JSON format then we display as it is.
        } else if ((oldValue && typeof (oldValue) == 'string') || (newValue && typeof (newValue) == 'string')) {
          result.push({ oldValue, newValue, fieldName });
        }
      }
      return result;
    }
  },
  methods: {     
    showActivityDetails() {
      this.showTable = !this.showTable;
    },      
    getDetailsLinkText() {
      return !this.showTable ? 'EXPAND' : 'COLLAPSE';
    }   
  }
}
</script>
<style lang="scss" scoped>
.kpt-activity-log-item {
  display: grid;
  grid-template-columns: 40px 90px auto;
  margin-top:5px;

  .kpt-activity-log-item-icon {
    padding: 12px;
  }

  .kpt-activity-log-item-ts {
    padding: 12px 0;
    strong {
      display: block;
      margin-bottom: -5px;
    }
  }

  .kpt-activity-log-item-msg {
    padding: 12px;
  }
}

.kpt-activity-log-table {
  margin-left:40px;  
}
</style>
